export default function defined(...args) {
    let ret = true;
    args.forEach(arg => ret = ret && typeof arg !== 'undefined');
    return ret;
}